import React, { useState } from 'react';
import { Plus, Camera, Zap, Shield, Truck, Package } from 'lucide-react';

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        {
            icon: Camera,
            q: "Какие бренды техники есть?",
            a: "Canon, Nikon, Sony, Fujifilm, Panasonic и другие топовые бренды"
        },
        {
            icon: Truck,
            q: "Как быстро доставка?",
            a: "По Ташкенту 1-2 дня. По Узбекистану 3-5 дней. Бесплатно от 1 млн сум"
        },
        {
            icon: Shield,
            q: "Какая гарантия?",
            a: "Официальная гарантия 1-3 года + сервисный центр"
        },
        {
            icon: Package,
            q: "Можно вернуть товар?",
            a: "14 дней на возврат/обмен при сохранении упаковки"
        },
        {
            icon: Zap,
            q: "Trade-in работает?",
            a: "Да! Принимаем старую технику в зачет новой покупки"
        }
    ];

    return (
        <div className="py-24 px-4 relative overflow-hidden">
            <div className="absolute top-20 right-20 w-72 h-72 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>

            <div className="max-w-6xl mx-auto relative z-10">
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-3 bg-accent/10 border border-accent/20 rounded-full px-6 py-2 mb-6">
                        <span className="text-accent font-semibold text-sm">FAQ</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-3">
                        Быстрые ответы
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                    {faqData.map((item, index) => {
                        const Icon = item.icon;
                        const isOpen = openIndex === index;

                        return (
                            <div
                                key={index}
                                onClick={() => setOpenIndex(isOpen ? null : index)}
                                className={`relative cursor-pointer transition-all duration-500 ${isOpen ? 'md:col-span-2' : ''
                                    }`}
                            >
                                <div className={`bg-gradient-to-br from-[#2a2a2a] to-[#1f1f1f] rounded-2xl border transition-all duration-300 overflow-hidden ${isOpen
                                    ? 'border-accent/40 shadow-lg shadow-accent/20'
                                    : 'border-white/10 hover:border-accent/30'
                                    }`}>
                                    <div className="flex items-center gap-4 p-5">
                                        <div className={`p-2.5 rounded-xl transition-all duration-300 ${isOpen
                                            ? 'bg-accent/20 border-accent/40'
                                            : 'bg-accent/10 border-accent/20'
                                            } border`}>
                                            <Icon className={`w-5 h-5 transition-colors duration-300 ${isOpen ? 'text-accent' : 'text-accent/70'
                                                }`} />
                                        </div>
                                        <h3 className={`flex-1 font-semibold transition-colors duration-300 ${isOpen ? 'text-white' : 'text-gray-300'
                                            }`}>
                                            {item.q}
                                        </h3>
                                        <Plus className={`w-5 h-5 text-accent transition-transform duration-300 ${isOpen ? 'rotate-45' : 'rotate-0'
                                            }`} />
                                    </div>

                                    <div className={`transition-all duration-300 ${isOpen ? 'max-h-32 opacity-100' : 'max-h-0 opacity-0'
                                        }`}>
                                        <div className="px-5 pb-5 pt-0">
                                            <div className="pl-14 border-l-2 border-accent/30">
                                                <p className="text-gray-400 text-sm leading-relaxed">
                                                    {item.a}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {isOpen && (
                                    <div className="absolute inset-0 bg-accent/5 rounded-2xl blur-xl -z-10"></div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <div className="mt-12 text-center">
                    <p className="text-gray-400 mb-4">Остались вопросы?</p>
                    <div className="flex flex-wrap gap-3 justify-center">
                        <a
                            href="tel:+998909601201"
                            className="inline-flex items-center gap-2 bg-accent hover:bg-accent/90 text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-accent/30"
                        >
                            (90) 960-12-01
                        </a>
                        <a
                            href="tel:+998909083226"
                            className="inline-flex items-center gap-2 bg-[#2a2a2a] hover:bg-[#323232] border border-white/10 hover:border-accent/30 text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:scale-105"
                        >
                            (90) 908-32-26
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}